import isNil from 'lodash/isNil';
import Button from 'antd/es/button';
import styled from 'styled-components';
import { EXTRA_LARGE_VIEWPORT } from 'modules/theme/config';

import type { HTMLProps } from 'react';

interface ICourseImage extends Omit<HTMLProps<HTMLDivElement>, 'children' | 'ref' | 'as'> {
  $shrink: boolean;
  $height?: number;
  $backgroundSrc: string;
}

export const CourseImage = styled.div<ICourseImage>`
  display: block;
  border-radius: 24px;
  width: 100%;
  height: 0;
  background-size: contain;
  padding-top: ${({ $shrink, $height }) => (!isNil($height) && $shrink ? `${$height}px` : '150%')};
  filter: drop-shadow(0px 8px 16px rgba(104, 113, 123, 0.07));
  background: linear-gradient(rgba(56, 165, 255, 0) 0%, rgb(59 59 59 / 40%) 85.5%),
    url(${({ $backgroundSrc }) => $backgroundSrc}) no-repeat;
  transition: padding-top 0.266s ease-out;
  transition-delay: ${({ $height, $shrink }) => (!isNil($height) && $shrink ? '0' : '0.266s')};

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    padding-top: ${({ $height, $shrink }) => (!isNil($height) && $shrink ? `${$height}px` : '272%')};
    background-position-x: 30%;
    border-radius: 16px;
  }
`;

export const CourseInformationContainer = styled.div`
  position: relative;

  a {
    text-decoration: none;
    color: white;

    &:hover {
      color: white;
    }
  }
`;

interface ICourseInformationBlock {
  $height?: number;
  $shrink?: boolean;
}

export const CourseInformationBlock = styled.div<ICourseInformationBlock>`
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 10;
  bottom: 52px;
  left: 0;
  width: 100%;
  font-weight: 600;
  font-size: 18px;
  line-height: 1.3;
  transition: font-size 0.5s ease-out;
  transition-property: font-size, bottom, margin-top;
  transition-delay: ${({ $shrink }) => ($shrink ? '0' : '0.532s')};
  background: rgba(255, 255, 255, 0.5);
  padding: 12px;
  color: black;
  a,
  a:hover,
  a:active,
  a:visited {
    color: black;
  }

  @media (max-width: ${EXTRA_LARGE_VIEWPORT}px) {
    font-size: 14px;
  }

  ${({ $height = 230, $shrink }) => ($height <= 130 && $shrink ? 'display: none;' : null)};
`;

export const CourseInformationItem = styled.div`
  display: flex;
  align-items: center;

  svg {
    flex: 0 0 24px;
    margin-right: 16px;
    fill: black;
  }
`;

export const ExpandButton = styled(Button)`
  &.ant-btn,
  &.ant-btn:not([disabled]):active {
    position: absolute;
    bottom: 16px;
    right: 16px;
    background: transparent;
    color: black;
    background: rgba(255, 255, 255, 0.5);
    border: none;
    border-radius
    z-index: 3;
  }
`;

